var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('BasicButton',{staticClass:"basic-button--jangsabot",attrs:{"header":"단골 고객으로 매출 3배 만들기"},on:{"click":_vm.moveToJangsabot}},[_c('v-icon',{attrs:{"left":"","color":"#4163d5"}},[_vm._v("mdi-robot")]),_vm._v(" AI 장사비서 3개월 집중관리 ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }